// constants.ts

export const MODAL_CONTENT = {
    MATERIAL_TYPE: "materialType",
    MATERIAL_SIZE: "materialSize",
} as const;

export const MODAL_TITLES = {
    MATERIAL_TYPE: "Material Type",
    MATERIAL_SIZE: "Material Size",
} as const;

export const BUTTON_LABELS = {
    ADD_MATERIAL_TYPE: "Add Material Type",
    ADD_MATERIAL_SIZE: "Add Material Size",
} as const;

export const ERROR_MESSAGES = {
    UPDATE_TYPE: "Failed to update material type.",
    UPDATE_SIZE: "Failed to update material size.",
} as const;
